// core version + navigation, pagination modules:
import Swiper from "swiper/bundle";

// Home
const swiper = new Swiper(".homeSwiper", {
  spaceBetween: 10,
  paginationClickable: true,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination-news",
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-home',
    prevEl: '.swiper-button-prev-home',
  },
  breakpoints: {
    376: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 20
    },
    992: {
      slidesPerView: 2.5,
      spaceBetween: 30
    },
    1200: {
      slidesPerView: 3.5,
      spaceBetween: 30,
      slidesPerGroup: 3
    },
    1400: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 4
    }
  }
});


const testimonialSwiper = new Swiper(".homeTestimonialSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  paginationClickable: true,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination-homeTestimonial",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next-homeTestimonial",
    prevEl: ".swiper-button-prev-homeTestimonial"
  }
})

// Dashboard
const dashboardTestimonialSwiper = new Swiper(".dashboardTestimonialSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  paginationClickable: true,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination-testimonial",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next-home",
    prevEl: ".swiper-button-prev-home"
  },
  breakpoints: {
    992: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 30
    }
  }
})

// Careers
const careersTestimonialSwiper = new Swiper(".careersTestimonialSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  paginationClickable: true,
  pagination: {
    el: ".swiper-pagination-testimonial",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next-home",
    prevEl: ".swiper-button-prev-home"
  }
})

const careersSwiper = new Swiper(".careersSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  loop: true,
  paginationClickable: true,
  navigation: {
    nextEl: ".swiper-button-next-careers",
    prevEl: ".swiper-button-prev-careers"
  }
})

// About
const partnersSwiper = new Swiper(".partnersSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  paginationClickable: true,
  grabCursor: true,
  /*   pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }, */
  navigation: {
    nextEl: ".swiper-button-next-partner",
    prevEl: ".swiper-button-prev-partner"
  }
})

// Services
const myTimelineSwiper = new Swiper(".myTimelineSwiper", {
  slidesPerView: 1,
  direction: "vertical",
  paginationClickable: true,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
    /*     renderBullet: function(index, className) {
      let currentYear = document.querySelectorAll('.myTimelineSwiper .swiper-slide')[index].getAttribute('data-year');
      return '<div class="d-flex"><span class="' + className + '"></span><span>' + currentYear + '</span></div>';
    }  */
  },
  navigation: {
    nextEl: ".swiper-button-next-timeline",
    prevEl: ".swiper-button-prev-timeline"
  }
})

const specialistServiceSwiper = new Swiper(".specialistServiceSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  paginationClickable: true,
  grabCursor: true,
  pagination: {
    el: ".specialistServiceSwiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next-glance",
    prevEl: ".swiper-button-prev-glance"
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    575: {
      slidesPerView: 1.5,
      spaceBetween: 30
    },
    // when window width is >= 480px
    676: {
      slidesPerView: 2,
      spaceBetween: 20,
      slidesPerGroup: 2
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 2.5,
      spaceBetween: 20,
      slidesPerGroup: 3
    },
    // when window width is >= 640px
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 4
    }
  }
})

const whatWeDoSwiper = new Swiper(".whatWeDoSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  paginationClickable: true,
  grabCursor: true,
  navigation: {
    nextEl: ".swiper-button-next-wwd",
    prevEl: ".swiper-button-prev-wwd"
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    575: {
      slidesPerView: 1.5,
      spaceBetween: 30
    },
    // when window width is >= 480px
    676: {
      slidesPerView: 2,
      spaceBetween: 20,
      slidesPerGroup: 2
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
      slidesPerGroup: 3
    },
    // when window width is >= 640px
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 4
    }
  }
})

const glanceSwiper = new Swiper(".glanceSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  paginationClickable: true,
  pagination: {
    el: ".glanceswiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next-glance",
    prevEl: ".swiper-button-prev-glance"
  },
  breakpoints: {
    // when window width is >= 320px
    576: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    // when window width is >= 480px
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      slidesPerGroup: 2
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
      slidesPerGroup: 3
    },
    // when window width is >= 640px
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerGroup: 4
    }
  }
})


/*
  pagination: {
    el: ".assetManagementSwiper-pagination",
    clickable: true,
  },
*/
const assetManagementSwiper = new Swiper(".assetManagementSwiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  paginationClickable: true,
  navigation: {
    nextEl: ".swiper-button-next-asm",
    prevEl: ".swiper-button-prev-asm"
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    575: {
      slidesPerView: 1.5,
      spaceBetween: 30
    },
    // when window width is >= 480px
    676: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // when window width is >= 640px
    992: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    // when window width is >= 640px
    1200: {
      slidesPerView: 4,
      spaceBetween: 30
    }
  }
})

const companyProfileSwiper = new Swiper(".companyProfileSwiper", {
  spaceBetween: 30,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  navigation: {
    prevEl: ".swiper-button-prev-cps",
    nextEl: ".swiper-button-next-cps"
  }
})


